import styled from 'styled-components';
const FullscreenModalHeader = styled.header.withConfig({
  displayName: "FullscreenModalHeader",
  componentId: "t52u2w-0"
})(["padding:20px 40px;flex-grow:0;flex-shrink:0;display:flex;align-items:", ";justify-content:space-between;"], props => props.isMobileView ? 'start' : 'center');
export default FullscreenModalHeader;